import React from 'react';
import { BaseComponent } from "../../../../project/general";
import { render } from "preact";
import { ToggleButton } from "../../toggle-button";


class TimelineYearComponent extends BaseComponent {
    static getNamespace() {
        return 'timeline-year';
    }


    static getRequiredRefs() {
        return [
            "carousel",
            "carouselItem",
            "carouselItemHeading",
            "carouselItemText",
            "carouselItemLink",
            "carouselItemImg",
            "yearProgress",
            "carouselNavLabel",
            "carouselNavNext",
            "carouselNavPrev",
            "carouselNavLabelMob",
            "carouselNavNextMob",
            "carouselNavPrevMob",
            "backgroundTogglePlaceholder",
            "progressMarker",
            "startYear",
            "endYear"
        ];
    }


    items = [];
    currentIndex = 0;
    isTransitioning = false;
    decadeMsg = null;
    decadeMsgParagraph = null;
    decadeButtons = null;
    background = null;
    decadeSelect = null;
    selectedItem = null;


    cacheDomElements() {
        this.decadeMsg = document.querySelector(".decade-message");
        this.decadeMsgParagraph = this.decadeMsg?.querySelector("p");
        this.decadeButtons = document.querySelectorAll(".decade-button");
        this.background = document.querySelector(".ah-container");
        this.decadeSelect = document.querySelector(".ah-decade-select select");
    }


    bindEventListeners() {

            this.refs.carouselNavPrev.addEventListener("click", () => this.showPreviousItem());
            this.refs.carouselNavPrevMob.addEventListener("click", () => this.showPreviousItem());




            this.refs.carouselNavNext.addEventListener("click", () => this.showNextItem());
            this.refs.carouselNavNextMob.addEventListener("click", () => this.showNextItem());




        this.decadeButtons?.forEach(button => {
            button.addEventListener("click", (event) => {
                const itemId = event.target.getAttribute("data-item-id");
                this.updateCarousel(itemId);
                this.setActiveDecadeButton(event.target);
            });
        });


        if (this.decadeSelect) {
            this.decadeSelect.addEventListener("change", (event) => {
                const selectedOption = event.target.selectedOptions[0];
                const itemId = selectedOption.getAttribute("data-item-id");
                this.updateCarousel(itemId);
                const matchingButton = [...this.decadeButtons].find(btn =>
                    btn.getAttribute("data-item-id") === itemId
                );
                if (matchingButton) {
                    this.setActiveDecadeButton(matchingButton);
                }
            });
        }
    }


    setActiveDecadeButton(activeButton) {
        this.decadeButtons?.forEach(btn => btn.classList.remove("active"));
        activeButton.classList.add("active");
    }


    updateURL(decade, itemId) {
        const url = new URL(window.location);
        if (decade) url.searchParams.set("decade", decade);
        if (itemId) url.searchParams.set("itemId", itemId);
        window.history.replaceState({}, "", url);
    }


    updateCarousel(itemId, itemIdentifier = null) {
        return baseApi
            .get(`/api/TimelineItemsApi/GetTimelineItemsForDecade?decadeId=${itemId}`)
            .then((res) => {
                if (!res.data?.success) return;


                this.items = res.data.data || [];


                if (!this.items.length) {
                    this.toggleVisibility(false);
                    return;
                }


                this.startYear = itemId;
                this.endYear = itemId + 9;


                const foundIndex = itemIdentifier
                    ? this.items.findIndex(item => item.identifier === itemIdentifier)
                    : 0;


                this.currentIndex = foundIndex !== -1 ? foundIndex : 0;
                this.showItem(this.currentIndex);
                this.toggleVisibility(true);


                if (res.data.message) {
                    this.decadeMsgParagraph.textContent = res.data.message;
                    this.decadeMsg.classList.remove("hidden");
                } else {
                    this.decadeMsgParagraph.textContent = "";
                    this.decadeMsg.classList.add("hidden");
                }


                this.updateURL(itemId, this.items[this.currentIndex]?.identifier);
            })
            .catch((err) => {
                console.error("Failed to load timeline items:", err);
            });
    }


    toggleVisibility(show) {
        if (show) {
            this.refs.carousel.classList.remove("hidden");
        } else {
            this.refs.carousel.classList.add("hidden");
        }

        //if (showImage) {
        //    this.refs.carouselItemImg.parentNode.classList.remove("hidden");
        //} else {
        //    this.refs.carouselItemImg.parentNode.classList.add("hidden");
        //}
    }


    renderToggleButton = () => {
        var trueText = this.refs.backgroundTogglePlaceholder.dataset.trueText;
        var falseText = this.refs.backgroundTogglePlaceholder.dataset.falseText;
        render(
            <ToggleButton value={this.backgroundImageIsVisible()}
                          onToggle={this.toggleShowBackgroundImage}
                          trueText={trueText}
                          falseText={falseText}>
            </ToggleButton>,
            this.refs.backgroundTogglePlaceholder
        );
    }


    backgroundImageIsVisible = () => {
        return (localStorage.getItem("showBackgroundImage") == "true");
    }


    toggleShowBackgroundImage = () => {
        var value = !this.backgroundImageIsVisible();
        localStorage.setItem("showBackgroundImage", value);
        this.showOrHideBackgroundImage();
        return value;
    }


    showOrHideBackgroundImage() {
        if (this.selectedItem.hasBackgroundImage && this.backgroundImageIsVisible()) {
            this.background.style.setProperty('--dynamic-bg', `url(${this.selectedItem.backgroundImageUrl})`);
        } else {
            this.background.style.setProperty('--dynamic-bg', 'none');
        }
    }


    countUpTo(start = 0, target, callback, duration = 1000) {
        const numericStart = Number(String(start).replace("%", ""));
        const startTime = performance.now();
        const update = (currentTime) => {
            const elapsed = currentTime - startTime;
            const progress = Math.min(elapsed / duration, 1);
            const value = numericStart + (target - numericStart) * progress;
            callback(value);
            if (progress < 1) {
                requestAnimationFrame(update);
            }
        };
        requestAnimationFrame(update);
    }


    fadeOutElements() {
        const elements = [
            this.refs.carouselItemHeading,
            this.refs.carouselItemText,
            this.refs.carouselItemLink,
            this.refs.carouselItemImg
        ];
        elements.forEach(el => {
            el.style.transition = "opacity 0.3s ease-out";
            el.style.opacity = "0";
        });
    }


    fadeInElements() {
        const elements = [
            this.refs.carouselItemHeading,
            this.refs.carouselItemText,
            this.refs.carouselItemLink
        ];
        elements.forEach(el => {
            el.style.transition = "opacity 0.4s ease-in";
            el.style.opacity = "1";
        });
    }


    updateProgressElements(item) {
        this.countUpTo(this.refs.progressMarker.style.left, item.timelinePosition, value => {
            this.refs.progressMarker.style.left = `${value}%`;
        }, 500);


        this.countUpTo(this.refs.yearProgress.style.width, item.timelinePosition, value => {
            this.refs.yearProgress.style.width = `${value}%`;
        }, 500);


        this.refs.progressMarker.innerHTML = item.timelinePositionLabel;
        this.refs.progressMarker.style.display = 'block';
        this.refs.startYear.innerHTML = item.startYear;
        this.refs.endYear.innerHTML = item.endYear;
    }


    updateContentElements(item, index) {
        this.refs.carouselItemHeading.textContent = item.title;
        this.refs.carouselItemText.innerHTML = item.mainContent;
        this.refs.carouselNavLabel.innerHTML = `${index + 1}/${this.items.length}`;
        this.refs.carouselNavLabelMob.innerHTML = `${index + 1}/${this.items.length}`;
        if (item.hasLinkUrl) {
            this.refs.carouselItemLink.setAttribute("href", item.linkUrl);
            this.refs.carouselItemLink.classList.remove("hidden");
        } else {
            this.refs.carouselItemLink.setAttribute("href", "#");
            this.refs.carouselItemLink.classList.add("hidden");
        }
    } 

        //if (this.selectedItem.hasMainImage) {
        //    this.refs.carouselItemImg.setAttribute("src", this.selectedItem.mainImageUrl);
        //    this.refs.carouselItemImg.setAttribute("alt", this.selectedItem.mainImageAltText);
        //    this.refs.carouselItemImg.parentNode.classList.remove("hidden");
        //} else {
        //    this.refs.carouselItemImg.removeAttribute("src");
        //    this.refs.carouselItemImg.removeAttribute("alt");
        //    this.refs.carouselItemImg.parentNode.classList.add("hidden");
        //}

    updateImage(item) {
        return new Promise((resolve) => {
            if (item.hasMainImage) {
                const img = new Image();
                img.onload = () => {
                    document.querySelector('#item-image-url').setAttribute('value', item.mainImageUrl);
                    this.refs.carouselItemImg.setAttribute("src", item.mainImageUrl);
                    this.refs.carouselItemImg.setAttribute("alt", item.mainImageAltText);
                    this.refs.carouselItemImg.classList.remove("hidden");
                    setTimeout(() => {
                        this.refs.carouselItemImg.style.transition = "opacity 0.4s ease-in";
                        this.refs.carouselItemImg.style.opacity = "1";
                        resolve();
                    }, 50);
                };
                img.onerror = () => resolve();
                img.src = item.mainImageUrl;
            } else {
                this.refs.carouselItemImg.removeAttribute("src");
                this.refs.carouselItemImg.removeAttribute("alt");
                this.refs.carouselItemImg.classList.add("hidden");
                this.refs.carouselItemImg.style.opacity = "0";
                resolve();
            }
        });
    }


    showItem(index) {
        if (this.items.length <= index || this.isTransitioning) return;
        this.isTransitioning = true;
        const newItem = this.items[index];
        this.fadeOutElements();
        setTimeout(async () => {
            this.selectedItem = newItem;
            this.updateProgressElements(newItem);
            this.updateContentElements(newItem, index);
            await this.updateImage(newItem);
            this.showOrHideBackgroundImage();
            this.updateURL(this.startYear, newItem.identifier);
            setTimeout(() => {
                this.fadeInElements();
                this.refs.carousel.style.height = 'auto';
                setTimeout(() => {
                    this.isTransitioning = false;
                }, 400);
            }, 50);
        }, 300);
    }


    showNextItem() {
        if (!this.items.length || this.isTransitioning) return;
        if (this.currentIndex === this.items.length - 1) {
            const nextDecade = parseInt(this.startYear) + 10;
            const nextDecadeBtn = [...this.decadeButtons].find(btn =>
                btn.getAttribute("data-item-decade") == nextDecade
            );
            if (nextDecadeBtn) {
                const nextItemId = nextDecadeBtn.getAttribute("data-item-id");
                this.setActiveDecadeButton(nextDecadeBtn);
                this.updateCarousel(nextItemId);
                [...this.decadeSelect.options].forEach(option => {
                    option.selected = option.getAttribute("data-item-id") === nextItemId;
                });
            }
        } else {
            this.currentIndex++;
            this.showItem(this.currentIndex);
        }
    }


    showPreviousItem() {
        if (!this.items.length || this.isTransitioning) return;
        this.currentIndex = (this.currentIndex - 1 + this.items.length) % this.items.length;
        this.showItem(this.currentIndex);
    }


    onScript() {
        this.cacheDomElements();
        this.bindEventListeners();


        const params = new URLSearchParams(document.location.search);
        const requestedDecade = params.get("decade");
        const requestedItemId = params.get("itemId");


        let initDecadeBtn = [...this.decadeButtons].find(btn =>
            btn.getAttribute("data-item-decade") === requestedDecade
        ) || this.decadeButtons[0];


        if (initDecadeBtn) {
            const initItemId = initDecadeBtn.getAttribute("data-item-id");
            this.updateCarousel(initItemId, requestedItemId);
            this.setActiveDecadeButton(initDecadeBtn);
            [...this.decadeSelect.options].forEach(option => {
                option.selected = option.getAttribute("data-item-id") === initItemId;
            });
        }


        if (this.carouselItem) {
            this.refs.carouselItem.style.width = "100%";
        }


        this.renderToggleButton();
    }


    onInit() {
        this.onScript();
    }
}


export default TimelineYearComponent;





